module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "accountEditModal",
    attrs: {
      "id": "accountEditModal",
      "title": _vm.$t('account.modal.edit'),
      "no-close-on-backdrop": ""
    },
    on: {
      "show": _vm.setAccountEditData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.editAccount($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.application.nickname'),
      "state": _vm.accountEditNicknameState,
      "feedback": _vm.accountEditNicknameFeedback
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.accountEditData.nickname),
      callback: function($$v) {
        _vm.accountEditData.nickname = $$v
      },
      expression: "accountEditData.nickname"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('account.timezone'),
      "state": "success"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.accountEditTimezoneOptions,
      "required": ""
    },
    model: {
      value: (_vm.accountEditTimezone),
      callback: function($$v) {
        _vm.accountEditTimezone = $$v
      },
      expression: "accountEditTimezone"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Account edit actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.editAccount
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.save')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.hideAccountEditModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e2fc369"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/modals/AccountEditModal.vue
// module id = 492
// module chunks = 0